var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsWohlbefindenMdeFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 -1 32 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons-wohlbefinden-m\xFCde-filled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-wohlbefinden-m\\xFCde"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.560098,3.71192023 C12.7136414,1.52723136 5.27989828,4.50409833 1.83448361,10.8128116 C-1.60832089,17.1202197 -0.0944265685,24.9858827 5.44564361,29.5640718 C10.9857138,34.1409558 18.9936927,34.1461761 24.5402883,29.5745124 C28.6444641,26.1919023 30.5460554,21.006347 29.8641061,15.9802845 C29.6246506,14.2154642 29.0666577,12.4703086 28.1736347,10.8297775",
    id: "Stroke-13-Copy",
    stroke: "#7F8BDB",
    fill: "#7F8BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,15 C18.53875,15.6224029 19.48375,16 20.5,16 C21.51625,16 22.46125,15.6224029 23,15",
    id: "Stroke-1-Copy-4",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,15 C10.46125,15.6224029 9.51625,16 8.5,16 C7.48375,16 6.53875,15.6224029 6,15",
    id: "Stroke-3-Copy",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,22 C12.8946667,22 12,22.84 12,23.875 L12,25.125 C12,26.16125 12.8946667,27 14,27 C15.104,27 16,26.16125 16,25.125 L16,23.875 C16,22.84 15.104,22 14,22 Z",
    id: "Stroke-5-Copy",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.88,5 C32.394383,3.37666055 31.28024,2.44026316 29.64,2.63157895 C29.07944,1.26394737 27.93228,0 26.28,0 C24.2486,0 22.5308,1.29 22.36,3.15789474 C20.56828,3.31684211 19,4.85289474 19,6.57894737 C19,8.41184211 20.6898,10 22.64,10 L30.17592,10 C31.7358,10 33,8.83473684 33,7.36842105 C33,6.45710526 32.62536,5.47789474 31.88,5 Z",
    id: "Stroke-1-Copy-6",
    stroke: "#FFFFFF",
    fill: "#7F8BDB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsWohlbefindenMdeFilled);
export default __webpack_public_path__ + "static/media/icons-wohlbefinden-müde-filled.d638d10c7adb0157126b671514cfe8bf.svg";
export { ForwardRef as ReactComponent };